import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { markAllRead, setLoading, setNotifications } from '../../store/notificationsSlice';
import axiosClient from '../../axios-client';
import NotificationItem from './NotificationItem';

export default function NotificationsDropdown() {
  const dispatch = useDispatch();
  const { items, loading } = useSelector((state) => state.notifications);

  useEffect(() => {
    dispatch(setLoading(true));
    axiosClient.get('/notifications')
      .then(({ data }) => dispatch(setNotifications(data)))
      .finally(() => dispatch(setLoading(false)));
  }, [dispatch]);

  const handleMarkAllRead = () => {
    axiosClient.patch('/notifications/read-all')
      .then(() => dispatch(markAllRead()))
      .catch(() => {});
  };

  return (
    <div className="notifications-dropdown">
      <div className="notifications-header">
        <span>Notificaciones</span>
        {items.some((n) => !n.read) && (
          <button className="mark-all-btn" onClick={handleMarkAllRead}>
            Marcar todas como leídas
          </button>
        )}
      </div>

      <div className="notifications-list">
        {loading && <p className="notifications-empty">Cargando...</p>}
        {!loading && items.length === 0 && (
          <p className="notifications-empty">No tienes notificaciones</p>
        )}
        {!loading && items.map((n) => (
          <NotificationItem key={n.id} notification={n} />
        ))}
      </div>
    </div>
  );
}